<template>
  <component
    :is="tag"
    class="form-group"
    :class="{
      'form-row': isHorizontal,
    }"
  >
    <component
      :is="labelTag"
      v-if="label"
      :for="labelFor"
      :class="{
        'col-form-label': isHorizontal || isFieldset,
        [`col-${labelCols}`]: isHorizontal && labelCols,
        [`text-${labelAlign}`]: labelAlign,
        [labelClass]: labelClass
      }"
    >
      {{ label }}
    </component>

    <component :is="wrapper">
      <slot />
      <BFormInvalidFeedback
        v-if="invalidFeedback"
        :state="invalidFeedback"
        v-html="invalidFeedback"
      />
    </component>
  </component>
</template>

<script>
import BFormInvalidFeedback from './BFormInvalidFeedback.vue'
import BCol from './BCol.vue'

export default {
  name: 'BFormGroup',
  components: {
    BFormInvalidFeedback,
    BCol
  },
  props: {
    invalidFeedback: {
      type: String,
      default: undefined
    },
    label: {
      type: String,
      default: null
    },
    labelFor: {
      type: String,
      default: null
    },
    labelClass: {
      type: String,
      default: null
    },
    labelCols: {
      type: [Number, String, Object],
      default: null
    },
    labelAlign: {
      type: String,
      default: null
    }
  },
  computed: {
    isFieldset() {
      return !this.labelFor
    },
    isLegend() {
      return this.isFieldset
    },
    tag() {
      return this.isFieldset ? 'fieldset' : 'div'
    },
    labelTag() {
      return this.isLegend ? 'legend' : 'label'
    },
    isHorizontal() {
      return this.labelCols !== null
    },
    wrapper() {
      return this.isHorizontal ? BCol : 'span'
    }
  }
}
</script>
